// @ts-nocheck

import {DataModel, EntityModel} from '/ui/components/entitypicker/datasource/datamodel';
import {CollapsibleItem} from '/ui/components/entitypicker/entitylist/collapsibleitem';
import {EntityItem} from '/ui/components/entitypicker/entitylist/entityitem';
import {SeeMoreItem} from '/ui/components/entitypicker/entitylist/seemoreitem';
import {Pill} from '/ui/components/pill/pill';
import {yext} from '/ui/lib/msg';

import * as styles from '/ui/components/entitypicker/entitylist/itemlist.module.scss';
import LabelIcon from '/ui/icons/inline/label.svg';

/**
 * @param {{
 *   data: !DataModel,
 *   onSelect: function(EntityModel): ?,
 *   onShowMore: function(string): ?,
 *   collapsed: (boolean|undefined),
 * }} props
 * @returns {React.ReactElement}
 */
export const LabelList = ({
  data,
  onSelect,
  onShowMore,
  collapsed = true,
}) => {
  const labels = data.labels.items;
  const labelEntitiesModel = data.labelEntities;

  if (labels.length === 0) {
    return <div className={styles.noResultsMessage}>{yext.msg('There were no entities found')}</div>;
  }

  return (
    <ul>
      {
        labels.map(label => {
          const labelEntities = labelEntitiesModel.get(label.id);
          const total = labelEntities ? ` (${labelEntities.total})` : '';
          const labelSectionHeaderId = `_uep-label-header-${label.id}`;

          const labelContents = (
            <span id={labelSectionHeaderId}>
              {`${label.label}${total} `}
              {label.isInternal && <Pill text={yext.msg('Yext-Only')} type="internal" />}
            </span>
          );

          return (
            <CollapsibleItem
              icon={<LabelIcon />}
              label={labelContents}
              key={label.id}
              initialCollapsed={collapsed}
              collapsible={labelEntities && labelEntities.entities.length > 0}>
              <ul role="group" aria-labelledby={labelSectionHeaderId}>
                {
                  labelEntities && labelEntities.entities.map(entity => (
                    <EntityItem
                      entity={entity}
                      entityType={entity.typeId}
                      onClick={() => onSelect(entity)}
                      key={entity.id} />
                  ))
                }
                {
                  labelEntities && labelEntities.nextPageQuery
                      && <SeeMoreItem onClick={() => onShowMore(labelEntities.nextPageQuery)} />
                }
              </ul>
            </CollapsibleItem>
          );
        })
      }
    </ul>
  );
};
